export default __webpack_public_path__ + "static/Customer-Analytics-d413cbf14984a30eb7b2d176e014efa2.webp";